import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const FrontAuthmiddlewareDriver = ({ children, allowedRoles }) => {
  const location = useLocation();
  const authUser = JSON.parse(localStorage.getItem("authClient"));
  const userRole = localStorage.getItem("userRole");

  if (!authUser) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (authUser?.user_type != 'D') {
    return <Navigate to="/not-found" state={{ from: location }} />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
};

export default FrontAuthmiddlewareDriver;
